import React from 'react';
import { setCurrentView } from 'core/utils';
import { SplitFulfillmentOrderViewStore } from 'modules/order/stores';
import { SplitFulfillmentOrderTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new SplitFulfillmentOrderViewStore(rootStore, componentProps),
	'splitFulfillmentOrderViewStore'
)
class SplitFulfillmentOrder extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <SplitFulfillmentOrderTemplate {...this.props} viewStore={this.props.splitFulfillmentOrderViewStore} />;
	}
}

export default SplitFulfillmentOrder;
